import { observer, inject } from "mobx-react";
import React, { useEffect, useState, useRef } from "react";
import { Button } from "@material-ui/core";
import { RenderManualDataForPreview } from "./RenderManualDataForPreview";
import EventBus from "../../helper/event.bus";
import { eventBusMessages, eventTypesForBus } from "../../helper/enums";
import RenderDataStatusMessage from "./RenderDataStatusMessage"
import { ManualDataStatus } from "../../helper/constants";

const QarManualData = inject("RootStore")(
  observer(({ RootStore }) => {
    const [isDisabled, setIsDisabled] = useState(true);
    const [selectedFile, setSelectedFile] = useState(null);

    useEffect(() => {}, [RootStore.qarStore.manualDataForPreview?.manualDataInReview]);

    const fileInputRef = useRef(null);

    const handleFileChange = (event) => {
      const formData = new FormData();
      formData.append("file", event.target.files[0]);
      setSelectedFile(formData);
    };

    const handleChooseFile = () => {
      fileInputRef.current.click();
    };

    const handleFileUpload = () => {
      if (selectedFile) {
        RootStore.qarStore.uploadManualDataFile(selectedFile);
      } else {
        EventBus.publish(
          eventTypesForBus.fileNotSelected,
          eventBusMessages.fileNotSelected
        );
      }
    };

    const handlePreviewClick = () => {
      setIsDisabled(false);
    };

    return (
      <>
        <p>Manual Upload of Accounts</p>
        <div style={{ display: "inline-flex", gap: "10px", alignItems: "center" }}>
          <input
            type="file"
            accept=".xlsx"
            style={{ display: "none" }}
            ref={fileInputRef}
            onChange={handleFileChange}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleChooseFile}
            disabled={RootStore.qarStore.complianceReviews.some(
              (x) => !x.isManagerReviewAdminCompleted
            )}
          >
            Choose File
          </Button>
          {selectedFile && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleFileUpload}
            >
              Upload
            </Button>
          )}
          <Button
            variant="contained"
            color="primary"
            disabled={
              RootStore.qarStore.manualDataForPreview.status !== ManualDataStatus.Finished
            }
            onClick={handlePreviewClick}
          >
            Preview
          </Button>
          <RenderDataStatusMessage status={RootStore.qarStore.manualDataForPreview.status} disabled={!isDisabled} />
        </div>
        <RenderManualDataForPreview disabled={isDisabled} />
      </>
    );
  })
);

export default QarManualData;
